export default "<p>tabs works!</p>\n";